import { InstructionComponentProps } from "../InstructionComponent"
import ImageTextComponent from "../../ImageTextComponent"
import Button from "../../Button"

// Updated file names for clarity:
import Step3ImageA from "../../../resources/tutorial/PROFESSIONAL_REG_3A.png"
import Step3ImageB from "../../../resources/tutorial/PROFESSIONAL_REG_3B.png"
import Step3ImageC from "../../../resources/tutorial/PROFESSIONAL_REG_3C.png"

const ArztRegistrationStepThree: InstructionComponentProps = {
  name: "Schritt 3 von 3 – Praxis-Auswahl",
  path: "/help/arzt/registration-step3",
  description: "Wählen Sie Ihre Arztpraxis oder legen Sie eine neue an.",
  both: [
    // 1) Searching for existing practice
    <ImageTextComponent
      col={true}
      text={
        <>
          <h3 className="font-semibold text-lg">Vorhandene Praxis suchen</h3>
          <p>
            Wenn Sie in einem MVZ oder in einer Gemeinschaftspraxis arbeiten und
            ein Kollege Ihre Praxis bereits angelegt hat, können Sie sie hier in
            der Suchleiste finden.
          </p>
          <p className="mt-2">
            Geben Sie <b>den Namen oder einen Teil der Adresse</b> ein und
            klicken Sie auf <b>Suchen</b>, um die Praxis zu finden.
          </p>
        </>
      }
      images={[Step3ImageA]}
    />,

    // 2) Creating a new practice if not found
    <ImageTextComponent
      col={true}
      text={
        <>
          <h3 className="font-semibold text-lg">Eigene Praxis anlegen</h3>
          <p>
            Falls Sie Ihre Praxis nicht finden, können Sie sie anlegen. Geben
            Sie dafür Name, Adresse und ggf. weitere relevante Informationen ein.
          </p>
          <p className="mt-2">
            Klicken Sie dann auf <b>Praxis hinzufügen</b>, um Ihre Praxis im
            System zu erstellen.
          </p>
        </>
      }
      images={[Step3ImageB]}
    />,

    // 3) Final step: click “Registrierung abschließen”
    <ImageTextComponent
      col={true}
      text={
        <>
          <h3 className="font-semibold text-lg">
            Registrierung abschließen
          </h3>
          <p>
            Nachdem Sie Ihre Praxis ausgewählt oder neu angelegt haben, klicken
            Sie unten rechts auf <b>Registrierung abschließen</b>.
          </p>
          <p className="mt-2">
            Damit beenden Sie den Registrierungsprozess und können sich ab sofort
            mit Ihren Zugangsdaten einloggen.
          </p>
        </>
      }
      images={[Step3ImageC]}
  
    />
  ]
}

export default ArztRegistrationStepThree
